document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('newsletter-modal');
  if (!modal) return;

  // 1) Define global opener
  window.openNewsletterModal = () => modal.classList.add('is-open');

  // 2) Wire up *all* buttons with class .newsletter-open
document.querySelectorAll('.newsletter-open').forEach(btn => {
  btn.addEventListener('click', function(e) {
    e.stopPropagation();
    e.preventDefault();


    // 1️⃣ Read the tag from the opener
    const tag = btn.getAttribute('data-newsletter-tag') || 'newsletter';

    // 2️⃣ Find the hidden tags input and set its value
    const form = document.getElementById('newsletter-form');
    const tagInput = form.querySelector('input[name="contact[tags]"]');
    tagInput.value = tag;

    // 3️⃣ Open the modal
    openNewsletterModal();
  });
});




  // 3) Close handlers
  const closeBtn = modal.querySelector('.modal_close_button');
  if (closeBtn) {
    closeBtn.addEventListener('click', () =>
      modal.classList.remove('is-open')
    );
  }
  modal.addEventListener('click', e => {
    if (e.target === modal) modal.classList.remove('is-open');
  });

  // 4) Form submission
  const form = document.getElementById('newsletter-form');
  if (form) {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const email = form.email.value;
      console.log('Submit:', email);
      modal.classList.remove('is-open');
      if (!note) return;
      note.classList.add('active');
      // hide again after 2 seconds
      setTimeout(() => {
        note.classList.remove('active');
      }, 2000);
    });
  }
});

